<template>
  <div class="comp-template-paypanel">
    <bench-dialog
      v-model="panelVisible"
      width="858px"
      :appendToBody="false"
      :modalAppendToBody="false"
      @beforeClose="beforeClose"
    >
      <div v-if="wechat" class="panel-inner">
        <!-- 升级会员提示 -->
        <div class="panel-inner-part1">
          <h3 class="part-title part1-title">升级会员，免费使用该模板</h3>
          <!-- 升级个人会员 -->
          <div v-if="soloVipVisible" class="part1-ad">
            <bench-btn
              class="ad-btnlink"
              size="240px"
              label="开通动画Pro+会员"
              @click="adBtnClick(1)"
            ></bench-btn>
            <p class="ad-desc">
              低至
              <strong>￥2.7/天</strong> ，解锁
              <strong>5000+个精品模板、30万+个正版素材</strong>
            </p>
            <p class="ad-desc">
              还有无水印、高清导出等权益等你来用！
              <a
                href="/vipsolo"
                target="_blank"
                class="detail-link"
                @click="showPayChecker"
                >查看详情</a
              >
            </p>
          </div>
          <!-- 升级企业会员 -->
          <div v-if="compVipVisible" class="part1-ad">
            <bench-btn
              class="ad-btnlink"
              size="240px"
              label="开通企业VIP"
              @click="adBtnClick(2)"
            ></bench-btn>
            <p class="ad-desc">
              低至
              <strong>￥16.3/天</strong> ，解锁
              <strong>全站1万+个精品模板，100万+个正版素材。</strong>
            </p>
            <p class="ad-desc">
              企业VIP无水印、超清导出不限次数！
              <a
                href="/vip"
                target="_blank"
                class="detail-link"
                @click="showPayChecker"
                >查看详情</a
              >
            </p>
          </div>
          <div class="template-info">
            <div class="template-cover">
              <img :src="template.thumbnailUrl | assetsUrlFil" alt />
            </div>
            <div class="template-info-row">
              <el-tooltip
                effect="dark"
                :content="template.title"
                placement="bottom"
              >
                <span class="template-info-title">{{ template.title }}</span>
              </el-tooltip>
              <card-paytype-mark :template="template"></card-paytype-mark>
            </div>
          </div>
        </div>
        <!-- 购买模板 -->
        <div class="panel-inner-part2">
          <h3 class="part-title part2-title">单独购买该模板</h3>
          <!-- 微信支付成功前 -->
          <div v-if="!isPaySuccess" class="part2-main">
            <div class="part2-main-wxpay">
              <div class="qrcode-box">
                <qriously
                  v-if="timer"
                  :value="qrcode"
                  background="white"
                  :background-alpha="1"
                  :size="76"
                  mime="image"
                ></qriously>
                <div v-else class="qrcode-box-mask"></div>
              </div>
              <div class="qrcode-payment">
                <div class="qrcode-payment-row">
                  <div v-if="price - totalFee == 0" class="qrcode-price">
                    应付金额：
                    <span class="qrcode-price-num">￥{{ price }}</span>
                  </div>
                  <div v-else class="price">
                    <p class="price-origin">原价：{{ price }}元</p>
                    <p class="price-discount">
                      促销价：
                      <span class="discount-price">{{ totalFee }}</span> 元
                    </p>
                  </div>
                  <div class="qrcode-coupon" @click="visibleCoupon = true">
                    使用优惠券
                  </div>
                </div>
                <div class="qrcode-payment-row">
                  <iconfont
                    name="#icon-wx"
                    font-size="22px"
                    style="margin-right: 6px"
                  ></iconfont>
                  <span>使用微信扫码支付</span>
                  <p v-if="timer" class="qrcode-title">
                    (此二维码将在<span class="qrcode-title-count">{{
                      timerM
                    }}</span
                    >分<span class="qrcode-title-count">{{ timerS }}</span
                    >秒后失效)
                  </p>
                  <p v-else class="qrcode-title">
                    二维码已失效，点击
                    <a
                      href="javascript:;"
                      class="qrcode-title-link"
                      @click="refresh"
                      >刷新</a
                    >
                    重新获取。
                  </p>
                </div>
              </div>
            </div>
            <div class="part2-main-otherpay">
              <span class="otherpay-title">其他支付方式:</span>
              <span
                class="otherpay-method otherpay-alipay"
                @click="togglePayType(template, 'isAlipay')"
              >
                <iconfont
                  name="#icon-ali"
                  font-size="22px"
                  style="margin-right: 6px"
                ></iconfont
                >支付宝
              </span>
              <span
                class="otherpay-method otherpay-unionpay"
                @click="togglePayType(template, 'isUnionpay')"
              >
                <iconfont
                  name="#icon-union"
                  font-size="22px"
                  style="margin-right: 6px"
                ></iconfont
                >银联支付
              </span>
            </div>
          </div>
          <!-- 微信支付成功后 -->
          <div v-else class="pay-mask-success">
            <img src="./PayPanel/icons/pay-success.png" />
            <p>购买成功</p>
          </div>
        </div>
        <!-- 提示 -->
        <div class="panel-inner-part3">
          <p class="part3-tip">温馨提示:</p>
          <p class="part3-tip">
            单独购买模板仅享用该模板使用权益，仅可用于个人学习交流，不包括无水印、超清导出、商用授权等会员权益，如有需要请直接购买
            <a
              :href="soloVipVisible ? '/vipsolo' : '/vip'"
              class="part3-tip--link"
              target="_blank"
              @click="showPayChecker"
              >会员套餐</a
            >
            使用。
          </p>
        </div>
      </div>
    </bench-dialog>

    <!-- 阿里或银联支付跳回来后 -->
    <check-state
      v-model="checkVisible"
      :info="payInfo"
      @checkClose="closeHdl"
      @failClose="closeHdl"
    ></check-state>

    <!-- 优惠券弹窗 -->
    <coupon-dialog
      v-model="visibleCoupon"
      :coupon-type="'6'"
      :original-pirce="price"
      :use-alert="true"
      @selectTicket="selectTicketHdl"
    ></coupon-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import transTempTypeMixin from "@/platformCode/trans-temp-type.js";
export default {
  name: "",
  filters: {
    assetsUrlFil: (url) => {
      const fn = function (url) {
        let base = "https://resources.laihua.com";
        if (!url) {
          return "";
        }
        const httpReg = /^http/;
        if (httpReg.test(url)) {
          return url;
        }
        const reg = /^\//;
        if (!reg.test(url)) {
          return base + "/" + url;
        } else {
          return base + url;
        }
      };
      return fn(url);
    },
  },
  components: {
    BenchDialog: () => import("@/platformCode/benchDialog.vue"),
    checkState: () => import("@/platformCode/checkState"),
    cardPaytypeMark: () => import("@/platformCode/cardPaytypeMark"),
    benchBtn: () => import("@/platformCode/benchBtn.vue"),
    iconfont: () => import("@/platformCode/iconfont"),
  },
  mixins: [transTempTypeMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    template: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      analysis: {
        upgrade: {
          category: "upgrade_members",
          action: "click_tpl_upgrade",
          label: "升级会员_模板",
        },
      },
      payPanelVisible: false,
      isPaySuccess: false, // 是否购买成功
      price: "", //原价
      totalFee: "", // 实际支付价格
      qrcode: "", // 二维码数据
      timer: "init", // 轮询支付结果的定时器
      // new
      wechat: true, //支付方式默认微信
      checkVisible: false,
      timerM: 5, //分钟
      timerS: 0, //秒
      aliLink: "", //阿里支付链接
      aliTradeNo: "", //阿里支付生成的账单号
      uPayTradeNo: "", //银联支付生成的账单号
      tradeNo: "", // 阿里及银联账单号
      vipUpdated: false,
      payInfo: {
        type: "",
        tradeNo: "",
        templateId: "",
      },
    };
  },
  watch: {
    value(val) {
      this.payPanelVisible = val;
      if (val) {
        this.wechat = true;
        this.timerM = 5;
        this.timerS = 0;
        this.runPayment(this.template);
      }
    },
  },
  computed: {
    ...mapGetters(["tmpLevelType", 'UserLevelInfo', 'UserMsg']),
    panelVisible: {
      get() {
        return this.value;
      },
      set(nv) {
        this.$emit("input", nv);
      },
    },
    soloVipVisible() {
      // return this.template.payType === 1 && this.$store.getters["isPoor"];
      return [1, 4].includes(this.template.payType);
    },
    compVipVisible() {
      // return (
      //   this.template.payType === 6 &&
      //   (this.$store.getters["isPoor"] ||
      //     this.$store.getters["isSolo"] ||
      //     this.$store.getters["isTmpSolo"])
      // );
      return [6].includes(this.template.payType);
    },
    fromUwp() {
      return this.$route.query.from === "uwp" ? true : false;
    },
    // 神策：区分付款页面
    source() {
      const { path, name } = this.$route;
      let sr = "非指定source";
      if (name === "templates") {
        sr = "模板广场";
      }
      if (name === "theme") {
        sr = "模板主题页";
      }
      if (name === "export") {
        sr = "作品导出页-推荐位";
      }
      if (name === "solution-edu") {
        sr = "解决方案页面-教育培训";
      }
      if (name === "solution-medical") {
        sr = "解决方案页面-医疗健康";
      }
      if (name === "solution-科普讲解") {
        sr = "解决方案页面-教育培训";
      }
      if (name === "solution-med") {
        sr = "解决方案页面-传媒宣传";
      }
      if (name === "solution-adv") {
        sr = "解决方案页面-广告营销";
      }
      return sr;
    },
  },
  async mounted() {
    document.addEventListener("visibilitychange", this.tabWatcher);
    this.$bus.on("tellPayPanel", (name, value) => {
      this[name] = value;
    });
  },
  beforeDestroy() {
    window.removeEventListener("visibilitychange", this.tabWatcher);
  },
  methods: {
    beforeClose() {
      clearInterval(this.timer);
    },
    adBtnClick(type) {
      this.$util.localStorage.set("sensorWebPurchaseVipSource", {
        val: {
          routename: "tool",
          page: "编辑器-会员模板",
        },
      });
      this.$util.localStorage.set("sensorWebPayVipSource", {
        val: {
          routename: "tool",
          page: "编辑器-会员模板",
        },
      });
      this.$util.localStorage.set("saPurchaseSource", {
        fullPath: "/tool",
      });
      let path = "";
      let link = "";
      switch (type) {
        case 1:
          path = "/pvip?page=17";
          link = 'buyUpEnterpriseVip';
          break;
        case 2:
          path = "/pricing?page=17";
          link = 'buyEnterpriseVip';
          break;
      }
      // this.openWin(path);

      // this.showPayChecker();

      this.panelVisible = false;
      this.$memberGuide({
        show: true,
        context: this,
        funcRight: {
          type: "vipTemplate",
          name: "会员专属模板",
        },
        link
      });
    },
    showPayChecker() {
      this.$bus.emit("FeaturesPop_vue", {
        name: "vipPayment",
        msg: "请在相应的付款页面进行操作",
        btnClose: "遇到问题",
        btnMsg: "付款成功",
        fs: "payPriceEvent_vue",
        templateCheckId: this.template.checkId,
        msgType: 2,
        type: 2,
      });

      this.panelVisible = false;
    },
    openWin(url) {
      let tagA = document.createElement("a");
      tagA.href = url;
      tagA.target = "_blank";
      tagA.click(); //点击事件
      tagA.remove();
    },
    closeHdl() {
      this.closePanel();
    },
    updateVip() {
      window.open(location.origin + "/vipsolo");

      // 神策：设置支付vip来源source
      let source = {};
      source.routename = "templates-paypanel-upgrade";
      source.page = "平台-模板购买弹窗-会员引导按钮";
      source = {
        val: source,
      };

      // 神策埋点：记录购买vip（立即续费）的source
      this.$util.localStorage.set("sensorWebPurchaseVipSource", source);
      this.$util.localStorage.set("sensorWebPayVipSource", source);
    },
    // 监听当前tab是否可见状态
    tabWatcher() {
      if ((!document.hidden && this.tradeNo) || this.vipUpdated) {
        this.wechat = false;
        this.checkVisible = true;
        this.panelVisible = false;
        // document.title = document.hidden ? "离开了" : "回来了";
      }
    },
    // 微信支付
    runPayment(item) {
      const params = {
        isOrder: 1,
        id: item.id,
        source: this.source,
      };
      this.$axios.get("/api/user/template/relation", { params }).then((res) => {
        let data = res.data.data;
        this.qrcode = data.QRCode ? data.QRCode.code_url[0] : "";
        this.price = data.price;
        this.totalFee = data.totalFee;
        const tradeNo = data.tradeNo;

        let params = {
          tradeNo: tradeNo,
        };
        // 神策：获取支付vip的来源页面
        let source = this.$util.localStorage.get("sensorWebPayVipSource");
        if (source) {
          params.source = source.page;
        }

        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.$axios
            .get("/api/payment/checkFinished", { params })
            .then((res) => {
              let code = res.data.code;
              if (code === 200) {
                this.isPaySuccess = true;
                clearInterval(this.timer);
                setTimeout(() => {
                  this.qrcode = false;
                }, 3000);

                // if (this.fromUwp) {
                //   this.uwpHdl();
                //   return;
                // }
                // window.location.href = window.location.origin + `/tool?template=${this.template.checkId}`;

                this.$modal.show("openTemplate", {
                  id: this.template.checkId,
                });
                this.$bus.emit("template.payDone", this.template.checkId);
              }
            })
            .catch((error) => {});

          this.countDown();
        }, 1000);
      });
    },
    /**
     * type:
     * 银联支付 -- isUnionpay
     * 支付宝支付 -- isAlipay
     * window.open("about:blank", "unionPay");
     * window.open(null, "unionPay").location.href =data.data.url;
     */
    togglePayType(item, type) {
      let page = window.open("about:blank");
      clearInterval(this.timer);
      let params = {
        isOrder: 1,
        id: item.id,
        source: this.source,
      };
      params[type] = 1;
      this.$axios
        .get("/api/user/template/relation", { params })
        .then(({ data }) => {
          if (data.code === 200) {
            page.location.href = data.data.url;
            this.tradeNo = data.data.tradeNo;

            this.payInfo.type = type;
            this.payInfo.tradeNo = data.data.tradeNo;
            this.payInfo.templateId = item.id;
          }
        })
        .catch((err) => {
          // console.log(`err:`,err);
        });
    },
    // 倒计时
    countDown() {
      if (this.timerM >= 0 && this.timerS > 0) {
        this.timerS--;
      } else if (this.timerM && !this.timerS) {
        this.timerM--;
        this.timerS = 59;
      } else if (!this.timerM && !this.timerS) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    showService() {
      this.$store.dispatch('showServiceChat');
    },
    refresh() {
      this.timerM = 5;
      this.timerS = 0;
      this.runPayment(this.template);
    },
  },
};
</script>

<style lang="scss">
// .comp-bench-dialog .el-dialog__close {
//   color: #666666;
//   &:hover {
//     color: #9e9e9e;
//   }
// }
</style>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
.comp-template-paypanel {
  text-align: left;
  line-height: 1;
}
.panel-inner {
  padding: 5px 42px 24px 42px;
  line-height: 1;
}
.panel-inner-part1 {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #f8f8f8;
  padding-bottom: 40px;
}
.template-info {
  width: 239px;
}
.template-cover {
  background: #f1f3f7;
  height: 134px;
  text-align: center;
  & > img {
    height: 100%;
    object-fit: contain;
  }
}
.template-info-row {
  display: flex;
  align-items: center;
}
.template-info-title {
  flex: 1;
  padding: 10px;
  text-align: left;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.part-title {
  font-size: 20px;
  color: #333;
}
.part1-title {
  position: absolute;
  top: 0;
  left: 0;
}
.part1-ad {
  padding-top: 44px;
}
.ad-btnlink {
  // display: inline-block;
  // width: 240px;
  // height: 40px;
  // line-height: 40px;
  // border-radius: 4px;
  // color: #fff;
  // background-color: #2F57FD;
  // text-align: center;
  margin-bottom: 10px;
}
.ad-desc {
  color: #333;
  line-height: 2;
}
.detail-link {
  color: #2f57fd;
  text-decoration: underline;
}
.panel-inner-part2 {
  margin-top: 40px;
}
.part2-main {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 24px 37px;
  margin-top: 24px;
  line-height: 1;
}
.pay-mask-success {
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  & > img {
    margin-bottom: 20px;
  }
}
.part2-main-wxpay {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.qrcode-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 86px;
  height: 86px;
  border: 1px solid #e8e8e8;
  box-sizing: border-box;
  margin-right: 36px;
}
.qrcode-box-mask {
  width: 86px;
  height: 86px;
  background-color: #777;
}
.qrcode-payment {
  box-sizing: border-box;
  width: 430px;
  height: 86px;
  // padding: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.qrcode-payment-row {
  display: flex;
  align-items: center;
}
.qrcode-title {
  color: #ff293d;
  font-size: 12px;
  letter-spacing: 0px;
  margin-left: 10px;
}
.qrcode-title-count {
  display: inline-block;
  text-align: center;
}
.qrcode-title-link {
  color: #5778fb;
}
.qrcode-price {
  font-weight: bold;
  color: #333;
  margin-right: 19px;
}
.qrcode-price-num {
  color: #ff2a3e;
}
.price {
  font-size: 14px;
  color: #474261;
  margin-right: 19px;
}
.price-origin {
  text-decoration: line-through;
}
.price-discount {
  font-weight: bold;
  margin-top: 3px;
}
.discount-price {
  font-size: 24px;
  color: #f63830;
}
.qrcode-coupon {
  margin-right: 10px;
  border: 1px solid #d5d5d5;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  width: 100px;
  cursor: pointer;
  text-align: center;
}
.qrcode-prompt {
  color: #333;
}
.part2-main-otherpay {
  margin-top: 28px;
  display: flex;
  align-items: center;
}
.otherpay-title {
  margin-right: 39px;
}
.otherpay-method {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d5d5d5;
  border-radius: 4px;
  height: 40px;
  width: 140px;
  text-align: center;
  margin-right: 30px;
  cursor: pointer;
}
.panel-inner-part3 {
  margin-top: 20px;
  color: #333;
  line-height: 2;
}
.part3-tip--link {
  color: #2f57fd;
}
h3 {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/PayPanel.vue